// @flow

import React from 'react';
import DateFieldComponent from './date';

type ACFProps = {
  field_key: string,
  name: string,
  field_options: {
    end_year: string,
    start_year: string,
  },
};

const DateField = ({
  field_key,
  field_options: {
    end_year,
    start_year,
  },
  name,
}: ACFProps) => (
  <DateFieldComponent
    label={name}
    name={field_key}
    startYear={start_year}
    endYear={end_year}
  />
);

export default DateField;
